import { render, staticRenderFns } from "./addSQR.vue?vue&type=template&id=8390d05e&"
import script from "./addSQR.vue?vue&type=script&lang=js&"
export * from "./addSQR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports